import HttpClient from '../../../services/http-client';
import { ISgeDashboardResponse } from '../../../../model/sge/dashboard/dashboard-response';

const defaultPath = 'Dashboard';

const getOverview = async (): Promise<ISgeDashboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Overview`,
    }).then((response) => response.data);
};

const SgeDashboardAppService = {
    getOverview
};

export default SgeDashboardAppService;
